import { render, staticRenderFns } from "./GoodsModuleDetail.vue?vue&type=template&id=d2ccb34c&scoped=true&"
import script from "./GoodsModuleDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsModuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsModuleDetail.vue?vue&type=style&index=0&id=d2ccb34c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ccb34c",
  null
  
)

export default component.exports